import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'
import store from '../../store'
import {HTTP} from '@/main.js'

const state = { status: '', profile: {} }

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.username
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)
      HTTP.get('api/users/me/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }).then(resp => {
            localStorage.setItem('idSchool', resp.data.idSchool)
            localStorage.setItem('userData', JSON.stringify(resp.data))
            commit(USER_SUCCESS, resp.data)
            resolve(resp)
          }).catch(err => {
        commit(USER_ERROR, err.data)
        dispatch(AUTH_LOGOUT)
        localStorage.removeItem('idSchool')
        localStorage.removeItem('userData')
        reject(err)
      })
    })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
